import { useTranslation } from 'react-i18next';
import { reviews } from '@/mocks/reviews';
import ScrollReveal from '@/components/base/ScrollReveal';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`text-sm ${
            i < rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'
          }`}
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  const { t } = useTranslation('home');

  return (
    <section id="reviews" className="w-full py-16 md:py-20 bg-brand-light">
      <div className="px-4 md:px-6 lg:px-24 max-w-7xl mx-auto">
        {/* Section Header */}
        <ScrollReveal className="mb-10 md:mb-14 text-center">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-brand-mint" />
            <span className="text-sm font-medium tracking-wider uppercase text-brand-mint">
              {t('reviews_label')}
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-brand-dark font-heading leading-tight mb-4">
            {t('reviews_title')}
          </h2>
          <div className="w-10 h-1 bg-brand-mint rounded-full mx-auto" />
        </ScrollReveal>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {reviews.map((review, idx) => (
            <ScrollReveal key={review.id} delay={idx * 100}>
              <div className="bg-white rounded-xl p-6 md:p-7 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col h-full">
                {/* Quote icon */}
                <i className="ri-double-quotes-l text-2xl text-brand-mint/40 mb-3" />

                {/* Text */}
                <p className="text-sm text-brand-muted leading-relaxed flex-1 mb-5">
                  &ldquo;{review.text}&rdquo;
                </p>

                {/* Rating */}
                <div className="mb-4">
                  <StarRating rating={review.rating} />
                </div>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                  <div className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center shrink-0">
                    <span className="text-xs font-bold text-white">
                      {review.avatar}
                    </span>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-brand-dark">
                      {review.name}
                    </h4>
                    <p className="text-xs text-brand-muted">{review.role}</p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}